export default __webpack_public_path__ + "static/baidu-f5e1ac88d4b385a562f4ddece35531c6.svg";